export default "__VITE_ASSET__BSziFX9a__"